export const SiteTitle = '株式会社AIM ECサイト｜管理画面'
